import { createSafeContext } from '@/util';

import type { VTabContextValue } from './type';

const VTabContext = createSafeContext<VTabContextValue>(null, 'VTabContext');

export default VTabContext;
